import React from 'react';
import { FeatureFlagConfigChangeContext } from '../CommonProvider/FeatureFlagConfigChangeContext';
/**
 * React hook to retrieve the configuration change handler for feature flags.
 * This is useful when you want to subscribe to or trigger actions based on feature flag config changes.
 *
 * @returns {(() => void)} A callback function to handle configuration changes, or undefined if not available.
 */
export function useFeatureFlagConfigChange() {
    const { onConfigChanged } = React.useContext(FeatureFlagConfigChangeContext);
    return onConfigChanged;
}
